import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenContent', 'toggleButton']

  toggle() {
    const isHidden = this.hiddenContentTarget.style.display === 'none'
    this.hiddenContentTarget.style.display = isHidden ? 'block' : 'none'
    this.toggleButtonTarget.textContent = isHidden
      ? this.toggleButtonTarget.dataset.showLessLabel
      : this.toggleButtonTarget.dataset.showMoreLabel
  }
}
